module.exports = __webpack_public_path__ + "ebc139517bd7227d3009512adde96cb9.png";